import { render, staticRenderFns } from "./courseBox.vue?vue&type=template&id=84198de2&"
import script from "./courseBox.vue?vue&type=script&lang=ts&"
export * from "./courseBox.vue?vue&type=script&lang=ts&"
import style0 from "./courseBox.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports